import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "role-card-pocket"
};
const _hoisted_2 = {
  class: "group-container"
};
const _hoisted_3 = {
  class: "content-container"
};
const _hoisted_4 = {
  key: 0,
  class: "empty-data-container"
};
const _hoisted_5 = {
  key: 0,
  class: "empty-data-tips"
};
const _hoisted_6 = {
  key: 1,
  class: "empty-data-tips"
};
const _hoisted_7 = {
  key: 1,
  class: "props-list-container"
};
const _hoisted_8 = {
  key: 2,
  class: "pagination-container"
};
import { computed, onMounted, ref, watch } from 'vue';
import { ElMessage, ElRow } from 'element-plus';
import { request } from '@/manager/net_manager';
import MaskerLayer from '@/components/Basic/MaskerLayer.vue';
import PocketPropsCard from '@/components/Props/PocketPropsCard.vue';
import PocketPropsHeader from '@/components/Props/PocketPropsHeader.vue';
import PropsCard from '@/components/Props/PropsCard.vue';
import store from '@/store';
import { Grid } from "@element-plus/icons-vue";
export default {
  __name: 'RolePocket',
  props: {
    roleId: {
      type: [String, Number],
      required: true
    }
  },

  setup(__props) {
    const props = __props; // const {update: updateData} = inject('roleService')
    // refs

    const dataArray = ref([]);
    const roleProp = ref(null);
    const pagerCount = ref(5);
    const size = ref(21);
    const total = ref(0);
    const page = ref(0);
    const cacheFilterInfo = ref({});
    const existingTypes = ref([]);
    const existingTags = ref([]); // computed

    const worldOutlook = computed(() => store.state.world_outlook);
    const hasFilter = computed(() => {
      return Object.keys(cacheFilterInfo.value).length !== 0;
    }); // functions

    function getData(filterInfo = null) {
      roleProp.value = null;
      let parameters = {};
      parameters['role_id'] = props.roleId;
      parameters['world_outlook_id'] = worldOutlook.value.id;
      parameters['page'] = page.value;
      parameters['size'] = size.value;

      if (filterInfo) {
        Object.entries(filterInfo).forEach(item => {
          parameters[item[0]] = item[1];
        });
      } else if (hasFilter.value) {
        Object.entries(cacheFilterInfo.value).forEach(item => {
          parameters[item[0]] = item[1];
        });
      }

      request('props/role_props/list/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        if (filterInfo) {
          cacheFilterInfo.value = filterInfo;
        }

        dataArray.value = response.data.props;
        total.value = response.data.numbers; // console.log(JSON.stringify(response.data.existing_props_types), JSON.stringify(response.data.existing_props_tag))

        if (Object.keys(cacheFilterInfo.value).length === 0 && response.data.existing_props_types && response.data.existing_props_tag) {
          existingTypes.value = response.data.existing_props_types;
          existingTags.value = response.data.existing_props_tag;
        }
      });
    }

    function handlePageChange(index) {
      page.value = index - 1;
      getData();
    }

    const updateFilter = filterInfo => {
      page.value = 0;
      getData(filterInfo);
    };

    const selectedProp = item => {
      roleProp.value = item;
    };

    const closeProp = () => {
      roleProp.value = null;
    }; // lifecycle


    onMounted(() => {
      getData();
    }); // watcher

    watch(() => props.roleId, () => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_pagination = _resolveComponent("el-pagination");

      return __props.roleId ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(ElRow), {
        style: {
          "width": "100%",
          "align-items": "center",
          "justify-content": "space-between"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), {
          style: {
            "align-items": "center"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            size: 18
          }, {
            default: _withCtx(() => [_createVNode(_unref(Grid))]),
            _: 1
          }), _cache[0] || (_cache[0] = _createElementVNode("text", {
            class: "group-title"
          }, "持有道具项", -1))]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_withDirectives(_createVNode(PocketPropsHeader, {
        "existing-types": existingTypes.value,
        "existing-tags": existingTags.value,
        onUpdateFilter: updateFilter
      }, null, 8, ["existing-types", "existing-tags"]), [[_vShow, total.value !== 0 || hasFilter.value]]), total.value === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [!hasFilter.value ? (_openBlock(), _createElementBlock("text", _hoisted_5, "未发现持有物数据")) : (_openBlock(), _createElementBlock("text", _hoisted_6, "未发现检索数据"))])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (item, key) => {
        return _openBlock(), _createBlock(PropsCard, {
          key: key,
          data: item,
          "pocket-mode": true,
          onClick: $event => selectedProp(item)
        }, null, 8, ["data", "onClick"]);
      }), 128))])), total.value > size.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_pagination, {
        "page-size": size.value,
        "pager-count": pagerCount.value,
        layout: "prev, pager, next",
        total: total.value,
        background: true,
        onChange: handlePageChange
      }, null, 8, ["page-size", "pager-count", "total"])])) : _createCommentVNode("", true), roleProp.value !== null ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 3,
        onClose: closeProp
      }, {
        default: _withCtx(() => [_createVNode(PocketPropsCard, {
          "prop-id": roleProp.value.id,
          "role-id": __props.roleId,
          onUpdateProps: getData
        }, null, 8, ["prop-id", "role-id"])]),
        _: 1
      })) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true);
    };
  }

};